// extracted by mini-css-extract-plugin
export default {"imageWrapper":"DI-z","twoColumnImage":"EI-z"};